import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sellers'

const SellersApiV2 = {
  /**
   * Create merchant endpoint.
   * Invoke `POST api/v2/admins/sellers`
   * @param {object} seller_values
  */
  create: async (seller_values) => {
    const path     = API_PATH
    const body     = {
      seller: seller_values
    }
    const response = axios.post(path, body)
    return response
  },
  /**
   * Get list of Seller Inbound and its associations
   * Invoke `GET api/v2/admins/sellers
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = axios.get(path, { params })
    return response
  },
  /**
   * Get one `Seller`
   * @param {object} id seller id
   * @return {object} `seller`
   */
  show: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = axios.get(path)
    return response
  },
  /**
   * Update a `Seller`
   * @param {object} id seller id
   * @return {object} `seller`
   */
  update: async (id, seller_values) => {
    const path     = `${API_PATH}/${id}`
    const body     = {
      seller: seller_values
    }
    const response = axios.patch(path, body)
    return response
  },
  /**
   * Donwload list of Seller as CSV
   * Invoke `GET api/v1/admins/sellers/csv
   */
  DonwloadCsv: async () => {
    const path = `${API_PATH}/csv`

    const response = await axios.get(path, {})
    return response
  },
  /**
   * Update Seller's Identity Proof
   * Invoke `PATCH api/v2/admins/sellers/:id/identity_proof
   * @param {number} id - seller id
   * @param {string} identityType - identity proof type that is chosen (between KTP or SIM)
   * @param {object} identityType - Image File
   */
  identity_proof: async (
    id,
    identityType,
    identityProofImage
  ) => {
    const path     = `${API_PATH}/${id}/identity_proof`
    const formData = new FormData()
    formData.append('seller[identity_type]', identityType)
    formData.append('seller[identity_proof_image]', identityProofImage)

    const response = await axios.patch(path, formData)

    return response
  },
  /**
   * Get Seller's Identity Proof presigned url image
   * Invoke `PATCH api/v2/admins/sellers/:id/identity_proof
   * @param {number} id - seller id
   */
  show_identity_proof: async (id) => {
    const path     = `${API_PATH}/${id}/identity_proof`
    const response = await axios.get(path)
    return response
  }
}

export default SellersApiV2
